import { render, staticRenderFns } from "./TeamHockey.vue?vue&type=template&id=13a18f25&scoped=true&"
import script from "./TeamHockey.vue?vue&type=script&lang=js&"
export * from "./TeamHockey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a18f25",
  null
  
)

export default component.exports